import { TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import React, { useState } from 'react';

function AddMeasure() {
  const [chapterOpeningDate, setChapterOpeningDate] = useState<any>(new Date());
  const [explanatoryScreeningDate, setExplanatoryScreeningDate] = useState<any>(
    new Date()
  );
  const [bilateralScreeningDate, setBilateralScreeningDate] = useState<any>(
    new Date()
  );
  const [temporarilyClosedChapterDate, setTemporarilyClosedChapterDate] =
    useState<any>(new Date());
  const [resultDate, setResultDate] = useState<any>(new Date());
  return (
    <div className="py-10 px-2 overflow-auto gray-small-scroll h-full">
      <h1 className="text-[#04438b] text-4xl font-bold">
        ПОГЛАВЉЕ ПРЕГОВОРА О ПРИСТУПАЊУ
      </h1>
      <div className="rounded-lg border border-[#81848f3d] w-fit p-8 pb-4  mt-8 ">
        <h1 className="text-[#04438bae] text-2xl font-bold">СТАЊЕ ПРЕГОВОРА</h1>
        <div className="flex flex-wrap gap-2 ">
          <div className="flex flex-col items-center justify-center gap-6">
            <p className="w-[270px] h-[48px] text-[#3f4d5d] text-sm">
              ДАТУМ ОТВAРАЊА ПОГЛАВЉА
            </p>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="ДАТУМ"
                value={chapterOpeningDate}
                onChange={(newValue) => {
                  setChapterOpeningDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField size="small" sx={{ width: 200 }} {...params} />
                )}
              />
            </LocalizationProvider>
          </div>
          <div className="flex flex-col items-center gap-6">
            <p className="w-[270px] h-[48px] text-[#3f4d5d] text-sm">
              ДАТУМ ЕКСПЛАНАТОРНОГ СКРИНИНГА
            </p>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="ДАТУМ"
                value={explanatoryScreeningDate}
                onChange={(newValue) => {
                  setExplanatoryScreeningDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField size="small" sx={{ width: 200 }} {...params} />
                )}
              />
            </LocalizationProvider>
          </div>
          <div className="flex flex-col items-center gap-6">
            <p className="w-[270px] h-[48px] text-[#3f4d5d] text-sm">
              ДАТУМ БИЛАТЕРАЛНОГ СКРИНИНГА
            </p>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="ДАТУМ"
                value={bilateralScreeningDate}
                onChange={(newValue) => {
                  setBilateralScreeningDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField size="small" sx={{ width: 200 }} {...params} />
                )}
              />
            </LocalizationProvider>
          </div>
          <div className="flex flex-col items-center gap-6">
            <p className="w-[270px] h-[48px] text-[#3f4d5d] text-sm">
              ПРИВРЕМЕНО ЗАТВОРЕНО ПОГЛАВЉЕ НА МЕЂУВЛАДИНОЈ КОНФЕРЕНЦИЈИ
            </p>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="ДАТУМ"
                value={temporarilyClosedChapterDate}
                onChange={(newValue) => {
                  setTemporarilyClosedChapterDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField size="small" sx={{ width: 200 }} {...params} />
                )}
              />
            </LocalizationProvider>
          </div>
          <div className="flex flex-col items-center gap-6">
            <p className="w-[270px] h-[48px] text-[#3f4d5d] text-sm">
              ДАТУМ ДОБИЈАЊА РЕЗУЛТАТА
            </p>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="ДАТУМ"
                value={resultDate}
                onChange={(newValue) => {
                  setResultDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField size="small" sx={{ width: 200 }} {...params} />
                )}
              />
            </LocalizationProvider>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddMeasure;
